import { Link } from "react-router-dom"

const Button = ({link = false, href, to, text, color = 'bg-transparent', textColor = 'text-black', className, onClick, children}) => {
    return (
        link ? (
            <Link to={to} className={`px-5 py-1 rounded ${color} ${textColor} ${className}`} onClick={onClick}>{children}</Link>
        ) : (
            <a href={href} className={`px-5 py-1 rounded ${color} ${textColor} ${className}`} onClick={onClick}>{children}</a>
        )
    )
}

export default Button